export default __webpack_public_path__ + "static/media/share-image.0e7ecadc.png";